import { ExecutePipelineDetails } from "../execute.pipeline";
import {cutSuggestionsFromContent, extractQuestionSuggestions} from "@me8eon/messages";
import { PipelineDetailsData } from "../agent.card";
import { ErrorsOr, LogAnd } from "@me8eon/errors";

export type ExtractSuggestionsPipeline = {
    type: 'extractSuggestions'
}

export const extractSuggestionsPipeline = <Context, ExtractSuggestionsPipeline>(): ExecutePipelineDetails<Context, ExtractSuggestionsPipeline> => {
    return async (_p, d): Promise<LogAnd<ErrorsOr<PipelineDetailsData<Context>>>> => {
        const { suggestions = [], appendMessages } = d;

        const resultMessage = appendMessages && appendMessages.length > 0 ? appendMessages[appendMessages.length - 1] : undefined;
        if (!resultMessage) return { value: d, log: "no.resultMessage" };
        const { suggestions: fromResultMessage } = extractQuestionSuggestions(resultMessage.content);
        const finalSuggestions = [...suggestions, ...fromResultMessage];
        const cleanedContent = cutSuggestionsFromContent(resultMessage.content);

        const newAppendMessages = [...(appendMessages || []).slice(0, -1), { ...resultMessage, content: cleanedContent }];

        return {
            value: { ...d, appendMessages: newAppendMessages, suggestions: finalSuggestions },
            log: { whatHappened: "added.suggestions", params: fromResultMessage },
        };
    };
};